type Props = Readonly<{
  gameType: string
}>

export function GameLogo({ gameType }: Props) {
  const gameLogoMap: Record<string, string> = {
    marbles: 'logo-marbles',
    marbles_survivor: 'logo-marbles',
    stairpong: 'logo-stairpong',
    fishtank: 'logo-fishtank',
    ducks: 'logo-ducks',
    coin_flip: 'logo-coin_flip',
    irl: 'logo-irl',
    irl_alt: 'logo-cctv-game',
    duck_river: 'logo-cctv-game',
    snow_run: 'logo-cctv-game',
    social_betting: 'logo-cctv-game',
    crash: 'logo-irl',
    fast_lane: 'logo-marbles'
  }

  const logoClass = gameLogoMap[gameType] ?? 'logo-marbles'

  return (
    <div className={`game-card-logo ${logoClass}`}>
      <div className="game-card-logo-image" />
    </div>
  )
}
